import { Button, Text } from '@southfields-digital/mxmz-react-ui';
import { useEffect, useState } from 'react';

import { Dialog } from 'src/components/Dialog';
import { Contestant } from 'src/types/matchControl/contestant';

import MembersList from './MembersList';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  contestant: Contestant;
  onSubmit: (members: Contestant['members']) => void;
};

const LineUpDialog = ({ open, setOpen, contestant, onSubmit }: Props) => {
  const [members, setMembers] = useState(contestant.members || []);

  useEffect(() => {
    setMembers(contestant.members || []);
  }, [contestant.members]);

  const handleClickCancel = () => {
    setOpen(false);
    setMembers(contestant.members || []);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} className="w-[960px] max-w-[960px]">
      <div className="flex flex-col gap-4 p-4">
        <Text as="h2">Line-up: {contestant.name}</Text>
        <MembersList members={members} setMembers={setMembers} />
        <div className="flex justify-between gap-2">
          <Button onClick={handleClickCancel} variant="danger">
            Cancel
          </Button>
          <Button onClick={() => onSubmit(members)}>Submit</Button>
        </div>
      </div>
    </Dialog>
  );
};

export default LineUpDialog;
